import React from "react";
import { FAQContent } from "../modules/Faq";

const FAQ = () => {
  return (
    <div style={{ flex: "80%", padding: "2rem" }}>
      <FAQContent />
    </div>
  );
};

FAQ.propTypes = {};

export default FAQ;
